export default "__VITE_ASSET__5b8a103d__"